import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Text } from '../../ui-components/typography';
import { GetIcon } from '../icons';

interface ScarcityLabelProps {
    id?: string;
    children: ReactNode;
}

export const ScarcityLabel: FC<ScarcityLabelProps> = ({ children, id }) => (
    <div className="flex items-center gap-2">
        <GetIcon name="snail" size="sm" />
        <Text style="bold" id={id ?? 'scarcity-label'} as="span">
            {children}
        </Text>
    </div>
);

ScarcityLabel.propTypes = {
    id: PropTypes.string,
    children: PropTypes.node.isRequired,
};

ScarcityLabel.defaultProps = {
    id: undefined,
};
